import type { Temporal } from '@shared/lib/date-time';

import type { ClosableLocation } from './location-closure';

import { isLocationClosed, locationTitleWithClosedMark } from './location-closure';

/** Складская операция, для которой выбирается локация. */
export type LocationOperationMode = 'receipt' | 'writeoff';

/** Минимум полей локации, необходимый для построения опции селекта. */
export type OperationLocation = ClosableLocation & { id: string };

/** Форма опции `AppSelect`: type-alias, а не interface, — иначе теряется совместимость с `SelectOption`. */
export type LocationOperationOption = {
  value: string;
  label: string;
};

/**
 * Опции селекта локаций для складской операции.
 *
 * `receipt` — только открытые локации: приход в закрытую локацию отклоняет
 * `ProductStockLedger`, показывать её в выборе бессмысленно.
 * `writeoff` — все локации, закрытые с пометкой: остаток закрывшегося филиала
 * нужно уметь вынести.
 */
export const locationOperationOptions = (
  locations: readonly OperationLocation[],
  mode: LocationOperationMode,
  now?: Temporal.Instant,
): LocationOperationOption[] => {
  if (mode === 'receipt') {
    return locations
      .filter((location) => !isLocationClosed(location, now))
      .map((location) => ({ value: location.id, label: location.title }));
  }

  return locations.map((location) => ({
    value: location.id,
    label: locationTitleWithClosedMark(location, now),
  }));
};
